import { styled } from "styled-components";

export const SearchMemberPopupWrapper = styled.div`
  position: absolute;
  z-index: 1001;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  max-width: 484px;
  width: calc(100% - 32px);
  box-sizing: border-box;
  padding: 40px 15px 23.5px 15px;
  flex-direction: column;
  border-radius: 12px;
  gap: 12px;
  background: #fff;
`;

export const SearchMemberHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: Pretendard;
  font-size: 20px;
  font-weight: 600;
  text-align: left;
`;

export const SearchMemberListWrapper = styled.div`
  max-width: 488px;
  width: 100%;
  box-sizing: border-box;
  height: 128px;
  padding: 10px 15px 10px 15px;
  border-radius: 15px;
  background: #e5e5e5;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow-y: auto;
  top: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 5px;

  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  > .member {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 37px;
    box-sizing: border-box;
    padding: 10px 25px;
    border-radius: 14.71px;
    background: #ffffff;
    font-family: Pretendard;
    font-size: 14.67px;
    font-weight: 600;
    cursor: pointer;
  }
`;

export const SearchMemberButtonWrapper = styled.div`
  display: flex;
  gap: 20px;

  > .button {
    flex: 1;
    height: 48px;
    border-radius: 8px;
    line-height: 48px;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    color: #6436e7;

    &.purple {
      color: #fff;
      background: #7f25fb;
    }
  }
`;
